import React from 'react';
import { motion } from 'framer-motion';

/**
 * Reusable statistics card component
 * @param {string} label - Card label/title
 * @param {string|number} value - Main value to display
 * @param {string} valueColor - Tailwind color class for value (e.g., 'text-green-600')
 * @param {string} subtitle - Optional subtitle text
 * @param {React.ComponentType} icon - Heroicon component
 * @param {string} iconColor - Tailwind color class for icon (e.g., 'text-green-500')
 * @param {number} delay - Animation delay in seconds
 * @param {React.ReactNode} extra - Optional extra content below subtitle
 */
const StatCard = ({
  label,
  value,
  valueColor = 'text-gray-900',
  subtitle,
  icon: Icon,
  iconColor = 'text-gray-400',
  delay = 0.1,
  extra
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay }}
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500">{label}</p>
          <p className={`text-2xl font-bold mt-1 ${valueColor}`}>{value}</p>
          {subtitle && (
            <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>
          )}
          {extra}
        </div>
        {Icon && <Icon className={`h-10 w-10 ${iconColor}`} />}
      </div>
    </motion.div>
  );
};

export default StatCard;
